module.exports = "/images/circle-marker-leaf.png?6ff7a08729d659f101bfdf49342a7509";